import { Badge } from 'antd';
import { SegmentedLabeledOption, SegmentedValue } from 'antd/lib/segmented';
import Segmented from 'components/new-ui/base/segmented/Segmented';
import { StyledLabelWrapper } from './styles';

type Props = {
    value: SegmentedValue;
    options: (SegmentedLabeledOption & { badges?: number })[];
    showZero?: boolean;
    onChange?: (value: any) => void;
};

const SegmentedWithCountBadge = ({ value, options, showZero, onChange }: Props) => {
    return (
        <Segmented
            value={value}
            options={options.map(({ value, label, badges, disabled }) => {
                return {
                    label: (
                        <StyledLabelWrapper>
                            {label}
                            {(Number(badges) > 0 || showZero) && (
                                <Badge showZero={showZero} count={badges} color="var(--gray-6)" />
                            )}
                        </StyledLabelWrapper>
                    ),
                    value,
                    disabled,
                };
            })}
            onChange={onChange}
        />
    );
};

export default SegmentedWithCountBadge;
